<div class="p-md-5 p-3 faq-container" id="faq">
  <h2 class="text-uppercase text-center mb-5">Find the <i>answers</i> to your<br> questions <i>here</i></h2>

  <app-faq-card *ngFor="let faq of FAQs, index as i" [index]="i" [question]="faq.question" [answer]="faq.answer"></app-faq-card>
</div>